const notDisplayOnMapAcronyms = [
  'SFLS',
  'SROT',
  'SCUX',
  'IMMS',
  'SRTK',
  'TRBS',
  'SPUT',
  'SRDB',
  'SGDR',
  'SGDN',
  'SNYN',
  'SCAL',
  'SDOV'
]

export default notDisplayOnMapAcronyms
